import React from 'react'
import { Typography } from '@material-ui/core'
import { Link } from 'react-router-dom'
import { parseUtcTimestamp, formatUtcTimestamp, formatUtcTimeAgo } from 'utils/formatUtcTimestamp'

const STALE_THRESHOLD_HOURS = 24

function hoursAgo(value) {
    const d = parseUtcTimestamp(value)
    if (!d) return null
    return (Date.now() - d.getTime()) / 3600000
}

export function ClientStatusBanner({ client, clientLoading, clientAppPath, variant = 'overview' }) {
    if (clientLoading) return null

    if (client) {
        const lastHb = client.last_heartbeat
        const hbHours = hoursAgo(lastHb)
        const isStale = hbHours !== null && hbHours > STALE_THRESHOLD_HOURS

        return (
            <div className={`superadmin-heartbeat-banner ${isStale ? 'is-stale' : 'is-live'}`}>
                <span className="superadmin-heartbeat-banner__dot" />
                {isStale ? (
                    <Typography variant="body2" className="superadmin-heartbeat-banner__text">
                        <strong>Last heartbeat over 24 hours ago</strong> — {formatUtcTimeAgo(lastHb)} ({formatUtcTimestamp(lastHb)}). Client may be offline.
                    </Typography>
                ) : (
                    <Typography variant="body2" className="superadmin-heartbeat-banner__text">
                        <strong>Client connected</strong> — last heartbeat {formatUtcTimeAgo(lastHb)} ({formatUtcTimestamp(lastHb)})
                    </Typography>
                )}
            </div>
        )
    }

    return (
        <div className="superadmin-heartbeat-banner is-missing">
            <span className="superadmin-heartbeat-banner__dot" />
            <div>
                <Typography variant="body2" className="superadmin-heartbeat-banner__text">
                    <strong>No client app configured</strong> — this tenant has no dataprotected-node installation registered. Remote Control and heartbeat monitoring are unavailable.
                </Typography>
                {variant === 'overview' && clientAppPath && (
                    <Typography variant="body2" className="superadmin-heartbeat-banner__link">
                        View details on the <Link to={clientAppPath}>Client App</Link> tab.
                    </Typography>
                )}
            </div>
        </div>
    )
}
